export default __webpack_public_path__ + "static/969-f9e70dd428e993315bc693d3129acb72.gif";